module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pubitCssCls32"
  }, [_c('p', {
    staticClass: "pubitCssCls34"
  }), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }), _c('span', {
    staticClass: "Apple-style-span sgc-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls28"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls36"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls28"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Sunday, July 4")]), _c('span', {
    staticClass: "pubitCssCls37"
  }, [_vm._v("th")]), _c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v(", 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Late afternoon was hot and muggy on the holiday weekend on Santa Rosa Island. The bath house at the public access to Pensacola Beach was rumored to be a place where the occasional degenerate might get lucky and meet the occasional like-minded degenerate for the purpose of doing what like-minded degenerates like to do.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("The slim six foot tall man with dark hair was dressed in casual attire. Being a hot muggy day you would think he would be dressed in shorts and t-shirt instead of long black pants and white dress shirt.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("He was noticed immediately upon entering the bath house by a man in blue swim pants sitting in the back corner. The man was pretending to be changing clothes after a hot afternoon on the beach. He watched the new arrival with interest as he stepped up to the urinal and proceeded to relieve himself with a contented sigh.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("The man in the corner spoke, \"Too hot to be going out on the beach dressed like that.\" ")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Zipping up and stepping away from the urinal and glancing back to the corner he answered, \"Don't intend to go on the beach. I was just passing by and needed to make a pit stop.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("\"Well hell, guess that's allowed\", was the reply from the corner.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("\"Who are you the bath house police?\" ")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("\"No man, just making friendly conversation.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("The man in the white shirt asked, “Didn't your mother ever tell you not to talk to strangers?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("She did. Long time ago. But I never listened to her. Sorry if I bothered you, like I said, I'm just trying to be friendly.”")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls38"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("The new arrival thought,")]), _vm._v(" "), _c('span', {
    staticClass: "pubitCssCls39"
  }, [_vm._v("This would be the perfect time to start my mission. God must be presenting me with this opportunity")]), _c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v(". He said to the man in the corner, “What's your definition of friendly? Just how friendly do you want to get?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Corner man answered, \"Now that depends on you. I'm known to get real friendly if you know what I mean. By the way my name's Jesse, but my friends call me Skeeter\".")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("The new arrival thought to himself,")]), _vm._v(" "), _c('span', {
    staticClass: "pubitCssCls39"
  }, [_vm._v("Why are all the little wiry guys called Skeeter? Probably for the same reason all big guys are named Bubba. Whatever that reason is?")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("\"Well, Skeeter, I'm Frank and my friends call me Frank\", he said with a grin and added, \"I think I do understand what you mean about getting friendly. Tell you what, I'm staying back at the Hampton. How about meeting me in the lounge at about seven thirty and we can have a nice friendly discussion about life.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("\"Sounds good to me, I think I can make it. Yeah, OK, I'll be there Frank\", was Skeeter’s excited reply. Skeeter thought his vigilance had finally paid off.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls28"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("******************")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Frank was sitting in a booth and enjoying a Dewars on ice when Skeeter walked in. He motioned for Skeeter to join him in the booth.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("\"Have a seat\", Frank said. \"What will you have?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Skeeter slid into the booth opposite Frank, \"I worked up an awful beer thirst out on the beach today.”")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("\"You mean you were actually on the beach? I thought you just hung around in the bath house.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Extending his arms and turning them over Skeeter rebuked, \"Don't get a tan like this sitting around in no bath house.”")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("A dark haired waitress with a nametag that said “Beth” came by and Skeeter ordered a bottle of Corona. \"No mug. Just bring the bottle. And hurry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("The compliant waitress was back thirty seconds later with the Corona and Skeeter chugged half of it before he came up for air.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("\"Better bring another one Miss Beth, this one won't last too long.”")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("The waitress smiled and dutifully set out for another bottle of Corona.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("The sun had gone down by the time they had a few rounds and Frank said he felt like going for a short ride.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("\"I was hoping we were going to, you know, get together up in your room\", Skeeter said.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("\"We can get to that later\", Frank replied. \"I need to check something out before it gets too late. Why don't you come along.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("I guess I don't have anything better to do,” Skeeter replied.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Skeeter followed Frank out to the parking lot and into Frank’s new black F-250 diesel pickup.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("\"Wow. Nice truck. I would have guessed you were a luxury car type of guy. Thought you'd be driving a Lexus or something.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("\"Skeeter this truck is worth more than a Lexus and look around. You don't think you're sitting in luxury?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Skeeter recalled the diesel option and noted the tan leather seats and the myriad of options including the in-dash GPS; the sticker price must've been north of sixty grand.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("They left the hotel parking lot and drove over the Bob Sikes Bridge into Gulf Breeze, a small, quiet town located on the west end of the Fairpoint Peninsula between Pensacola and Santa Rosa Beach, accessed by causeways both north and south. The main artery between Pensacola and the beach runs through the east side of Gulf Breeze presenting heavy seasonal traffic. Most people, excitedly anticipating the beach, are unaware they are passing through a small town. The UFO incident of 1987 put Gulf Breeze on the map for a short period. A local man produced high quality pictures of UFO's that spread rapidly throughout the world’s newspapers and magazines. The pictures were later proven to be a hoax.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Turning left onto Fairpoint Drive, Skeeter asked where they were going and Frank said he had to check something out near the point. After about a mile and a half Frank slowed the truck and turned into the Forest Lawn Cemetery.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Feeling a bit uneasy Skeeter uttered, \"What are we doing here? Graveyards give me the creeps.”")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Frank said, \"Take it easy, Skeeter. We won't be here long.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Frank proceeded down the narrow drive then made a three point turnaround at the second cross drive and parked facing back the way they entered. The cemetery was small but secluded with many full grown moss covered oak trees and dense shrubbery between sections of graves.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Frank got out of the truck and told Skeeter to get out; that he wanted to take a short walk. He needed to pay his last respects to a recently deceased friend. Skeeter hesitatingly obeyed trying to overcome his phobia of cemeteries.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Frank reached into the truck and removed a small .38 revolver from the console, and without Skeeter noticing, stuck it in his back belt. They walked a short distance and Frank told Skeeter to stop between two grave markers surrounded by shrubbery.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Is this where your friend is buried?” Skeeter asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("I think it's somewhere around here,” Frank said.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Frank pretended to be searching for the grave marker for his friend.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Skeeter asked, “What was your friend’s name? I can help you look.”")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("His last name was Bixler. They said it was one of those small markers that just lay on the ground. Not a large upright headstone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("That's gonna be hard to find. It's starting to get pretty dark.”")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("I think that's it right over there,” Frank pointed in the direction of a grave surrounded by shrubbery on three sides. “Why don't you check the name, Skeeter. I'd do it but I have a painful knee.”")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }), _vm._v(" "), _c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Skeeter had to get down on hands and knees to read the inscription on the small marker. He started to say it was the wrong grave when three quick shots rang out. Frank said under his breath, “I think it was the right grave, Skeeter. Another pestilence removed from God's good earth. Fitting name, ‘Skeeter.’”")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Frank pulled Skeeter’s pants down over his butt. “Good Lord,” Frank thought, “he didn't even have underwear on.” Frank reached into his shirt pocket and found the yellow post it note pad. He wrote a brief note and stuck it to Skeeter’s rear end. He made sure he left nothing behind and calmly walked to his truck. He made his way back to Fairpoint Drive and took a left across the Pensacola Bay Bridge into Pensacola.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("On the northwest side of Pensacola he slowly pulled into the Mighty Oaks RV Park located just off Interstate 10. It was past ten o'clock and was now the quiet time in the park. He quietly made his way back the gravel drive to his travel trailer, locked his truck, and entered his RV. Feeling thirsty he selected a bottle of water from the refrigerator and settled down into his rocker with his bible. He opened the bible to the third book of the Old Testament and smiled. He felt content in knowing his God would be pleased with him.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 69
// module chunks = 0